<template>
  <b-container fluid id="start-container">
    <v-stepper v-model="e1">
      <v-stepper-header>
        <b-row class="stepper-row">
          <b-col cols="11">
            <b-row> </b-row>
          </b-col>
          <b cols="1">
            <img v-if="internet == 'on'" class="internet-logo" src="../assets/on.svg" alt="internet" />
            <img v-if="internet == 'off'" class="internet-logo" src="../assets/off.svg" alt="internet" />
          </b>
        </b-row>
      </v-stepper-header>

      <v-stepper-items class="wrapper rebate-wrapper">
        <!-- Login -->
        <v-stepper-content step="1" v-if="ok">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row">
              <b-col cols="12" sm="12">
                <h2 class="rebate-header">
                  <img class="header-icon" src="../assets/login.svg" alt="Login" />
                  {{ $t("login.logindescription") }}
                </h2>
                <br />
                <span class="error-login" v-if="error">{{ errorMsg }}</span>
                <b-form-group class="form-element" label-cols="12" label-cols-md="5" label-size="md" v-bind:label="$t('login.youremail')" label-for="email">
                  <b-form-input size="lg" class="rebate-lg-input" v-model="userCredentials.username" @keyup.enter.native="step1" type="text" name="email"></b-form-input>
                  <div v-if="$v.userCredentials.username.$error">
                    <b-form-invalid-feedback v-if="!$v.userCredentials.username.required">{{ $t("rebate.requiredfield") }}</b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!$v.userCredentials.username.email">{{ $t("rebate.invalidemail") }}</b-form-invalid-feedback>
                  </div>
                </b-form-group>
                <b-form-group class="form-element" label-cols="12" label-cols-md="5" label-size="sm" v-bind:label="$t('login.yourpass')" label-for="password">
                  <b-form-input size="lg" class="rebate-lg-input" v-model="userCredentials.password" @keyup.enter.native="step1" type="password" name="password"></b-form-input>
                  <div v-if="$v.userCredentials.password.$error">
                    <b-form-invalid-feedback v-if="!$v.userCredentials.password.required">{{ $t("rebate.requiredfield") }}</b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </b-col>
              <b-button type="submit" tabindex="0" @click="step1" class="mmm-button next intro"
                >{{ $t("landing.beginbutton") }}
                <hr class="mmm-bar main-gradient" />
                <hr class="white-bar" />
              </b-button>
            </b-row>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </b-container>
</template>

<script>
import { getHeader } from "../headers.js";
import { required, email } from "vuelidate/lib/validators";

import { useSessionStore } from "../session";
import { openDB } from "idb";

export default {
  props: ["userProfile"],

  data() {
    return {
      e1: 1,
      userCredentials: {
        // username: "rhagle.cw@mmm.com",
        // password: "1057Oxford",
        // device_name: "electron",
        username: "",
        password: "",
        device_name: "electron",
      },
      userPin: "",
      ok: false,
      internet: "off",
      error: false,
      pinerror: false,
      pinerrorMsg: "",
      viewable: false,
      errorMsg: "",
      percent: "",
      runpercent: "",
      files: "",
      serveurl: "",
      extractionid: "",
      filecount: 0,
      filenumber: 0,
      progress: 0,
      loggedin: false,
      pinin: false,
      updatecheck: false,
      runupdate: false,
      optionstep: 6,
      daycount: [
        {
          value: "",
          text: "",
        },
      ],
      languages: [
        {
          value: "",
          text: "",
        },
      ],
      countries: [
        {
          value: "",
          text: "",
        },
      ],
      province: null,
      duration: null,
      country: null,
      provinces: {},
      durations: {},
      countires: {},
      language: null,
      // languages: [
      //   { text: "English", value: "en" },
      //   { text: "French", value: "fr" },
      // ],
      instructor: {},
      current: {
        topic: {
          name: "",
          icon: "",
          id: "",
          courses: [
            {
              id: "",
              icon: "",
              name: "",
              certdate: "",
              options: [
                {
                  id: "",
                  course_id: "",
                  code: "",
                  day: "",
                  country: "",
                  states: "",
                  language: "",
                  active: "",
                  presentation: {
                    id: "",
                    option_id: "",
                    filename: "",
                    fivepoint_status: "",
                    activated: "",
                  },
                },
              ],
            },
          ],
        },
      },
      selected: {
        topicid: "",
        courseid: "",
        presid: "",
        code: "",
        day: "",
        country: "",
        state: "",
        language: "",
        filename: "",
        paramduration: "",
        paramcountry: "",
        paramlanguage: "",
      },
    };
  },
  validations: {
    userCredentials: {
      username: {
        required,
        email,
      },
      password: {
        required,
      },
    },
    userPin: {
      required,
    },
  },

  mounted() {
    let vm = this;
  },
  created() {
    let vm = this;
    this.sessionStore = useSessionStore();

    vm.sessionStore.loadUser();
    vm.sessionStore.loadInstructor();
    vm.sessionStore.loadJWT();
    vm.sessionStore.loadDownloads();

    console.log(`vm.$root.isLoggedIn`, vm.$root.isLoggedIn);

    if (window.navigator.onLine && vm.$root.isLoggedIn) {
      vm.revalidate();
      vm.internet = "on";
    } else if (vm.$root.isLoggedIn) {
      vm.reroute();
      vm.loggedin = true;
    } else {
      vm.e1 = 1;
      vm.ok = true;
    }
  },

  methods: {
    step1: function () {
      //LOGIN SCREEN
      let vm = this;
      this.$v.$touch();
      if (this.$v.userCredentials.username.$invalid) {
        return;
      }
      this.$v.$reset();
      vm.loginAuthAttempt();
    },
    loginAuthAttempt: function () {
      //Send a post request to API for user login
      //I might need a client secret and client ID. For now, it doesn't seem like it but be aware.
      let vm = this;
      let dom = this.api + "/api/login";
      var config = {
        method: "post",
        url: dom,
        headers: {
          "Content-Type": "application/json",
        },
        data: vm.userCredentials,
      };

      vm.axios(config)
        .then(function (response) {
          //Start a cookie session. More secure than localstorage. Be aware of CRSF.
          vm.error = false;
          var d = new Date();

          vm.sessionStore
            .setUser({ name: response.data.token, expiry: d })
            .then(() => {
              console.log("User has been set");
              vm.$emit("getToken", response.data.token);
              vm.sessionStore.setJWT(response.data.token);
              vm.getInstructor();
              vm.$root.isLoggedIn = true;
              vm.loggedin = true;
            })
            .catch((error) => {
              console.error("Failed to set user:", error);
            });
        })
        .catch(function (error) {
          console.log(error);
          vm.error = true;

          vm.sessionStore
            .clearUser()
            .then(() => {
              console.log("User has been cleaered");
            })
            .catch((error) => {
              console.error("Failed to clear user:", error);
            });

          vm.$root.isLoggedIn = false;
          if (vm.i18n.locale == "fr") {
            vm.errorMsg = "Une erreur est survenue.";
          } else {
            vm.errorMsg = "There was an error. Please try again.";
          }
          if (error.response.data.message) {
            vm.errorMsg = error.response.data.message;
          }
          if (error.response.status == 403) {
            vm.errorMsg = error.response.data.message;
          }
        });
    },

    reroute: function () {
      let vm = this;
      this.sessionStore = useSessionStore();
      console.log("reroute");
      if (window.navigator.onLine && vm.$root.isLoggedIn) {
        this.sessionStore.loadDownloads().then((data) => {
          if (data == undefined) {
            this.$router.push({ path: "downloads" });
          } else {
            this.$router.push({ path: "start" });
          }
        });
      } else {
        this.$router.push({ path: "start" });
      }
    },

    revalidate: async function () {
      let vm = this;
      let dom = this.api + "/api/me";
      const user = await vm.sessionStore.loadUser();
      let token = user.name;
      // console.log(`token: `, token);
      var config = {
        method: "get",
        url: dom,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      vm.axios(config)
        .then(function (response) {
          console.log("revalidate", response.data);
          vm.loggedin = true;
          vm.getInstructor();
        })
        .catch(function (error) {
          vm.error = true;
          vm.ok = true;
          if (vm.i18n.locale == "fr") {
            vm.errorMsg = "Une erreur est survenue.";
          } else {
            vm.errorMsg = "There was an error. Please try again.";
          }
          if (error.response.status == 403) {
            vm.sessionStore
              .clearUser()
              .then(() => {
                console.log("User has been cleaered");
              })
              .catch((error) => {
                console.error("Failed to clear user:", error);
              });
            vm.$root.isLoggedIn = false;
            vm.e1 = 1;
            vm.errorMsg = error.response.data.message;
          }
        });
    },

    getInstructor: async function () {
      let vm = this;
      let dom = this.api + "/api/userdatadesktop";

      // Wait for the user to load and get the token
      const user = await vm.sessionStore.loadUser();
      let token = user.name;

      let clientdata = null;

      const instruct = await vm.sessionStore.loadUser();
      if (instruct) {
        clientdata = instruct;
        console.log("this data is sent", clientdata);
      }

      var config = {
        method: "post",
        url: dom,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: clientdata,
      };
      vm.axios(config)
        .then(function (response) {
          // console.log('this data is returned', response.data);
          vm.sessionStore
            .setInstructor({ data: response.data })
            .then(() => {
              console.log("Instructor set");
              vm.instructor = response.data;
              console.log(response.data);
              vm.reroute();
            })
            .catch((error) => {
              console.error("Failed to set instructor:", error);
            });
        })
        .catch(function (error) {
          vm.error = true;
          if (vm.i18n.locale == "fr") {
            vm.errorMsg = "Une erreur est survenue.";
          } else {
            vm.errorMsg = "There was an error. Please try again.";
          }
        });
    },
  },
  beforeCreate: function () {
    let vm = this;
    this.sessionStore = useSessionStore();

    this.sessionStore.loadJWT().then((data) => {
      console.log(`hwt`, data);
      if (data && data.trim() !== "") {
        // console.log("JWT is present, setting isLoggedIn to true");
        vm.$root.isLoggedIn = true; // User is logged in
      } else {
        // console.log("No JWT found, setting isLoggedIn to false");
        vm.$root.isLoggedIn = false; // User is not logged in
      }
    });
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
</style>
